var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field__toggle"},[_c('input',_vm._g(_vm._b({staticClass:"field__toggle__input display--none",attrs:{"type":"checkbox"},domProps:{"checked":_vm.checked}},'input',Object.assign({}, _vm.$attrs,
            ( !_vm.allowFilling && { disabled: true })),false),Object.assign({}, ( _vm.allowFilling && {
                change: _vm.toggle
            })))),_c('label',{class:[
            'field__toggle__label position--relative display--block',
            { 'pointer': _vm.allowFilling }
        ],attrs:{"for":_vm.$attrs.id}})])}
var staticRenderFns = []

export { render, staticRenderFns }